import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { StatsSection } from '../components/StatsSection';
import { BlogExcerpts } from '../components/BlogExcerpts';
import { NearestLocationFinder } from '../components/NearestLocationFinder';
import { BookingCTA } from '../components/BookingCTA';
import { InsuranceLogos } from '../components/InsuranceLogos';
import { VirtualTryOn } from '../components/VirtualTryOn';
import { ReviewsSection } from '../components/ReviewsSection';
import { ReviewExcerpts } from '../components/ReviewExcerpts';
import { SocialMediaSection } from '../components/SocialMediaSection';
import { ShopFramesSection } from '../components/ShopFramesSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-847" />
      <ServicesSection data-id="element-848" />
      <VirtualTryOn data-id="element-849" />
      <ReviewExcerpts data-id="element-850" />
      <StatsSection data-id="element-851" />
      <BlogExcerpts data-id="element-852" />
      <ShopFramesSection data-id="element-853" />
      <NearestLocationFinder data-id="element-854" />
      <SocialMediaSection data-id="element-855" />
      <BookingCTA data-id="element-856" />
      <InsuranceLogos data-id="element-857" />
      <ReviewsSection data-id="element-858" />
    </>;
}